import { render } from "./FuFuFuFu.vue?vue&type=template&id=07ffc4ee"
import script from "./FuFuFuFu.vue?vue&type=script&lang=js"
export * from "./FuFuFuFu.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__